// import React from "react";
// import "./Thanku.css";
// import { FaDownload } from "react-icons/fa";
// import Header from "../header/header";
// import Footer from "../footer/footer";

// function ThankYouPage() {
//   return (
//     <div>
//       <Header />
//       <div className="thanks-container">
//         <div className="thank-you-image">
//           <span>Thank You</span>
//         </div>

//         <div className="content-card">
//           <h1>Welcome aboard!</h1>

//           <p>You’ve taken the first step with AstroBhagya.</p>
//           <p>
//             {" "}
//             For quick chats and expert insights, download the app and stay
//             connected, anytime.
//           </p>

//           <button
//             className="download-button"
//             onClick={() => window.open("https://play.google.com/store/apps/details?id=com.astrobhagyap", "_blank")}
//           >
//             <FaDownload className="download-icon" />
//             <span>Download the app</span>
//           </button>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// }

// export default ThankYouPage;



// import React from "react";
// import "./Thanku.css";
// import { FaDownload } from "react-icons/fa";
// import Header from "../header/header";
// import Footer from "../footer/footer";

// function ThankYouPage() {
//   const handleDownload = () => {
//     // Meta Tracking for Direct Page Download
//     if (window.fbq) {
//       window.fbq('track', 'Lead', { 
//         content_name: 'Valentine Download Page',
//         content_category: 'Mobile App' 
//       });
//     }
//     window.open("https://play.google.com/store/apps/details?id=com.astrobhagyap", "_blank");
//   };

//   return (
//     <div className="thanks-page-wrapper">
//       <Header />
      
//       <div className="ab-universe-main">
//         {/* Deep Space Background Effects */}
//         <div className="cosmic-nebula"></div>
//         <div className="cosmic-stars"></div>
        
//         {/* Shooting Stars Animation */}
//         <div className="shooting-star"></div>
//         <div className="shooting-star"></div>
//         <div className="shooting-star"></div>
//         <div className="shooting-star"></div>

//         <div className="ab-cosmic-card-full">
//           <div className="ab-cosmic-header">
//              <div className="ab-logo-universe-box">
//                 <img 
//                   src={require("../../assets/AstrobhagyaLogoo.webp")} 
//                   alt="AstroBhagya Logo" 
//                   className="ab-main-universe-logo animated-logo" 
//                 />
//                 <img 
//                   src={require("../../assets/AstrobhagyaName.webp")} 
//                   alt="AstroBhagya Name" 
//                   className="ab-main-universe-name" 
//                 />
//              </div>
//           </div>

//           <div className="ab-cosmic-body">
//             <h1 className="cosmic-title-stylish">Love is in the Stars</h1>
            
//             <div className="valentine-offer-box-full">
//               <p className="valentine-tagline">Special Valentine Week Offer</p>
//               <h2 className="valentine-main-offer">START YOUR FIRST CHAT FOR FREE</h2>
//             </div>

//             <p className="cosmic-desc-full">
//               Are the stars guiding you to your soulmate? Get ancient wisdom and clear guidance on your love life from our best astrologers.
//             </p>
            
//             <div className="ab-cosmic-spacer"></div>

//             <div className="btn-container-center">
//               <button className="ab-cosmic-btn-premium" onClick={handleDownload}>
//                 <FaDownload className="cosmic-icon" />
//                 <span>DOWNLOAD NOW</span>
//               </button>
//             </div>
            
//             <p className="ab-cosmic-subtext">Join our community of happy couples today</p>
//           </div>

//           <div className="neon-border-line"></div>
//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// }

// export default ThankYouPage;

import React from "react";
import "./Thanku.css";
import { FaDownload } from "react-icons/fa";
import Header from "../header/header";
import Footer from "../footer/footer";

function ThankYouPage() {
  const handleDownload = () => {
    if (window.fbq) {
      window.fbq('track', 'Lead', { 
        content_name: 'Valentine Download Page',
        content_category: 'Mobile App' 
      });
    }
    window.open("https://play.google.com/store/apps/details?id=com.astrobhagyap", "_blank");
  };

  return (
    <div className="thanks-page-wrapper">
      <Header />
      
      <div className="ab-universe-main">
        {/* Deep Space Background Effects */}
        <div className="cosmic-nebula"></div>
        <div className="cosmic-stars"></div>
        
        {/* Shooting Stars */}
        <div className="shooting-star"></div>
        <div className="shooting-star"></div>

        {/* Semi-Transparent Card for Clarity */}
        <div className="ab-cosmic-card-full">
          
          <div className="ab-cosmic-header">
             <div className="ab-logo-universe-box">
                <img 
                  src={require("../../assets/AstrobhagyaLogoo.webp")} 
                  alt="AstroBhagya Logo" 
                  className="animated-logo" 
                />
                <img 
                  src={require("../../assets/AstrobhagyaName.webp")} 
                  alt="AstroBhagya Name" 
                  className="ab-main-universe-name-call" 
                />
             </div>
          </div>

          <div className="ab-cosmic-body">
            
            <h1 className="cosmic-title-stylish">Guidance is in the Stars</h1>
            
           <div className="valentine-offer-box-full">
    <h2 className="valentine-main-offer-thanku">GET YOUR FIRST CHAT FOR FREE</h2>
    {/* <div className="promo-code-thanku">ASTRO20</div> */}
  </div>

  <p className="cosmic-desc-full">
    Facing confusion in love, career, or health? Download our app now and get a
    <strong style={{color: '#ff007f'}}> FREE session</strong> with India's top astrologers for instant clarity.
  </p>
           {/* <div className="valentine-offer-box-full">
    <h2 className="valentine-main-offer-thanku">GET UPTO 20% OFF WITH CODE</h2>
    <div className="promo-code-thanku">ASTRO20</div>
  </div>

  <p className="cosmic-desc-full">
    Facing confusion in love, career, or marriage? Download the app and use code 
    <strong style={{color: '#ff007f'}}> ASTRO20</strong> to get upto 20% off on your first session with real astrologers.
  </p> */}
            
            <div className="ab-cosmic-spacer"></div>

            <div className="btn-container-center">
              <button className="ab-cosmic-btn-premium" onClick={handleDownload}>
                <FaDownload className="cosmic-icon" />
                <span>DOWNLOAD NOW</span>
              </button>
            </div>
            
            <p className="ab-cosmic-subtext">Join our community of happy couples today</p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ThankYouPage;